import { Button, Input, Modal } from "@mui/joy";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../appConstants";
import React, { Dispatch, SetStateAction, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import appError from "../../appError";
import { useSelector } from "react-redux";
import Joi from "joi";
type EditDataProps = {
  cat_type_id: string;
  cat_type_name: string;
};
type AddKeywordTypeProps = {
  setModalToggle: Dispatch<SetStateAction<boolean>>;
  cat_type: string;
  fetchCatdata: () => void;
  editData: EditDataProps;
};

const UpdateCategoryModal: React.FC<AddKeywordTypeProps> = ({
  setModalToggle,
  cat_type,
  fetchCatdata,
  editData,
}) => {
  const brandId = useSelector((state: any) => state.appData.brand_id);
  const [principal_category, setPrincipal_category] = useState<string>(
    editData?.cat_type_name
  );
  const [loading, setLoading] = useState<boolean>(false);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPrincipal_category(value);
  };

  const onProceedClick = async () => {
    const schema = Joi.object({
      brand_id: Joi.string().guid({ version: "uuidv4" }).required(),
      cat_type: Joi.string()
        .valid("PRINCIPAL", "MAIN", "CATEGORY", "SUB")
        .required(),
      cat_type_name: Joi.string().required(),
      cat_type_id: Joi.string().guid({ version: "uuidv4" }).required(),
    });
    let data = {
      brand_id: brandId,
      cat_type:
        cat_type === "Principal Category"
          ? "PRINCIPAL"
          : cat_type === "Main Category"
          ? "MAIN"
          : cat_type === "Category"
          ? "CATEGORY"
          : "SUB",
      cat_type_name: principal_category,
      cat_type_id: editData?.cat_type_id,
    };
    const validate = schema.validate(data);
    if (validate.error) {
      appError(validate?.error?.toString());
      return;
    }
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const res = await axios.put(
        `${BASE_URL}categorymaster/category?brand_id=${brandId}&cat_type=${data?.cat_type}&cat_type_name=${data.cat_type_name}&cat_type_id=${editData?.cat_type_id}`,
        {},
        { headers }
      );
      const { message } = res?.data?.data;
      setPrincipal_category("");
      toast.success(message);
      setModalToggle(false);
      fetchCatdata();
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      open={true}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      className="h-full"
    >
      <div
        style={{ width: 790, backgroundColor: `${WHITE.W_100}` }}
        className="flex flex-col items-center rounded-[18px] px-10 py-10 gap-10"
      >
        <div className="flex flex-col items-start self-stretch gap-6 ">
          <div className="flex flex-col w-full">
            <div
              className="self-stretch"
              style={{
                color: `${BLACK.B_100}`,
                fontSize: 16,
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              Update {cat_type}
            </div>
            <div
              className="self-stetch"
              style={{
                color: `${BLACK.B_40}`,
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              Enter the details to update a {cat_type}
            </div>
          </div>

          <div className="flex flex-col w-full gap-1">
            <div
              className="flex flex-col h-[20px] justify-center self-stretch"
              style={{
                fontSize: 14,
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              {cat_type}
            </div>
            <Input
              placeholder={`Enter the ${cat_type}`}
              value={principal_category}
              className="flex px-4 py-5 items-center self-stretch gap-6 rounded-[8px] "
              sx={{
                "--Input-focusedThickness": "0px",
                height: "52px",
                border: `1px solid ${BLACK.B_10}`,
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "20px",
                backgroundColor: `${WHITE.W_100}`,
                boxShadow: "none",
              }}
              name="principal_category"
              onChange={onChangeHandler}
            />
          </div>
        </div>

        <div className="flex items-start justify-center gap-4 self-stretch">
          <Button
            color="neutral"
            sx={{
              height: "48px",
              width: "50%",
              backgroundColor: BLACK.B_5,
              color: BLACK.B_100,
              ":hover": {
                backgroundColor: BLACK.B_20,
              },
              padding: "8px 16px",
            }}
            onClick={() => setModalToggle(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={onProceedClick}
            sx={{
              height: "48px",
              width: "50%",
              backgroundColor: PRIMARY.P_BLue,
              padding: "8px 16px",
            }}
            loading={loading}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateCategoryModal;